var map = {
	"./TYPER.mp4": 6830,
	"./prjcts-oldtype1r.mp4": 5236,
	"./prjcts-oldtyper.mp4": 1247,
	"./prjcts-pasionargenta.mp4": 1825,
	"./prjcts-retroport.mp4": 5539,
	"./prjcts-spacedementia.mp4": 6704,
	"./prjcts-xavia.mp4": 3355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5823;